function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 20.75V12.75M0.75 12.75V2.75M0.75 12.75L3.22067 12.2559C4.8712 11.9258 6.58211 12.0828 8.14493 12.708C9.83848 13.3854 11.7024 13.5119 13.472 13.0695L13.5721 13.0445C14.1582 12.898 14.4361 12.2269 14.1253 11.7089L12.5647 9.10779C12.2232 8.53863 12.0524 8.25405 12.0119 7.94451C11.9951 7.81539 11.9951 7.68461 12.0119 7.55549C12.0524 7.24595 12.2232 6.96137 12.5647 6.39221L13.8432 4.26132C14.1778 3.7036 13.6711 3.01972 13.0401 3.17746C11.5513 3.54967 9.98308 3.44323 8.55821 2.87329L8.14493 2.70797C6.58211 2.08284 4.8712 1.92576 3.22067 2.25587L0.75 2.75M0.75 2.75V0.75",
  stroke: "#A6A6A6",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var SvgFlagEmpty = function SvgFlagEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag_empty.990d5c9f.svg";
export { ForwardRef as ReactComponent };